import { render } from "./LoginComponent.vue?vue&type=template&id=27f06c20&scoped=true&ts=true"
import script from "./LoginComponent.vue?vue&type=script&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=27f06c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f06c20"]])

export default __exports__